var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-table',{scopedSlots:_vm._u([{key:"default",fn:function({ data }){return _vm._l((data),function(tr,i){return _c('vs-tr',{key:i},[_c('vs-td',[_vm._v("\n                    Hello\n                ")])],1)})}}])},[_c('template',{slot:"thead"},[_c('th',[_vm._v("Cliente")]),_c('th')])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }